import { render, staticRenderFns } from "./VendorLedgers.vue?vue&type=template&id=34f87195"
import script from "./VendorLedgers.vue?vue&type=script&lang=js"
export * from "./VendorLedgers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f87195')) {
      api.createRecord('34f87195', component.options)
    } else {
      api.reload('34f87195', component.options)
    }
    module.hot.accept("./VendorLedgers.vue?vue&type=template&id=34f87195", function () {
      api.rerender('34f87195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Vendors/VendorLedgers.vue"
export default component.exports